import { Keys, Scene } from "excalibur";
import { playerState } from "./../state/stateManager";
import { goToScene } from "../main";
import { Resources } from "../Resources";
import flowerBG from "./../../res/flowerBG.jpg";
export default class GameIntro extends Scene {
  constructor() {
    super();
    this.container = document.getElementById("cutSceneText");
    this.resetIntro();
  }
  resetIntro() {
    this.pauseCount = 0;
    this.lines = 0;
    this.index = 0;
    this.contentIndex = 0;
    this.finished = false;
    this.totallyFinished = false;
    this.showedLetter = false;
  }
  onActivate() {
    this.resetIntro();
    this.container.style.display = "flex";
    this.container.style.opacity = 1;
    this.contentState = playerState.getContent().gameIntro;
    this.content = this.contentState.firstContent;
    this.container.innerHTML = `
    <div id="flowerBG" style="background-image: url('${flowerBG}')"></div>
    <div id="cutText0"></div>
      <div id="cutText1"></div>
      <div id="cutText2"></div>
      <div id="cutText3"></div>
      <div id="cutContinue"></div>
   `;
    console.log(
      "cut : conttentState: ",
      this.contentState,
      " content: ",
      this.content
    );
    this.textBox0 = document.getElementById("cutText0");
    this.textBox1 = document.getElementById("cutText1");
    this.textBox2 = document.getElementById("cutText2");
    this.textBox3 = document.getElementById("cutText3");
    this.continue = document.getElementById("cutContinue");
    this.text = ["", "", "", ""];
    this.startTyping();
  }
  startTyping() {
    console.log("inside starttyping: cutText");
    this.typing = setInterval(() => {
      if (!this.finished) {
        if (this.pauseCount < 20) {
          this.pauseCount++;
        } else if (this.pauseCount == 20) {
          this.pauseCount++;
        } else if (this.pauseCount > 20) {
          if (this.index !== this.content[this.lines].length) {
            this.text[this.lines] =
              this.text[this.lines] +
              this.content[this.lines].charAt(this.index);
            Resources.Keypress.play();
            this.index++;
          } else {
            this.lines++;
            this.index = 0;
            this.pauseCount = 0;
            if (this.lines == this.content.length) {
              console.log("dialog setting this.finished");

              if (this.contentIndex == 0) {
                this.enterPress();
              } else {
                this.finished = true;
                this.continue.innerHTML = `<p class="small">ENTER> Continue</p>`;
              }
            }
          }
          switch (this.lines) {
            case 0:
              this.textBox0.innerHTML = `<p>${this.text[0]}</p>`;
              break;
            case 1:
              this.textBox1.innerHTML = `<p>${this.text[1]}</p>`;
              break;
            case 2:
              this.textBox2.innerHTML = `<p>${this.text[2]}</p>`;
              break;
            case 3:
              this.textBox3.innerHTML = `<p>${this.text[3]}</p>`;
              break;
            default:
              break;
          }
        }
      }
    }, 70);
  }
  destroy() {
    this.container.style.display = "none";
  }
  finish() {
    this.container.style.opacity = 0;
    this.container.style.display = "none";
    let letter = this.contentState.letterContent;
    this.showedLetter = false;
    setTimeout(() => {
      console.log("inside cut timer ");
      this.container.style.display = "flex";
      this.showedLetter = true;
      this.container.style.opacity = 1;
      this.container.innerHTML = `<div id="flowerBG" style="background-image: url('${flowerBG}')"></div><div id="letterPaper"><img src="/images/grandpaPortrait.png"/>${letter}</div>`;
    }, 1000);
    this.totallyFinished = true;
  }
  nextContent() {
    this.contentIndex++;
    this.finished = false;
    this.content = this.contentState.secondContent;
    this.lines = 0;
    this.index = 0;
    this.text = ["", "", "", ""];
    this.textBox0.innerHTML = "";
    this.textBox1.innerHTML = "";
    this.textBox2.innerHTML = "";
    this.textBox3.innerHTML = "";
    this.continue.innerHTML = "";
    this.startTyping();
  }
  enterPress() {
    console.log("inside enterpress dialog");
    if (this.totallyFinished) {
      if (this.showedLetter) {
        this.destroy();
        this.resetIntro();
        this.container.style.display = "none";
        goToScene("homeIntro");
      }
    } else {
      if (this.finished) {
        if (this.contentIndex == 0) {
          this.nextContent();
        } else {
          this.finished = true;

          this.finish();
        }
      } else {
        this.finished = true;
        this.textBox0.innerHTML = `${this.content[0]}`;
        if (this.content[1] !== undefined) {
          this.textBox1.innerHTML = `${this.content[1]}`;
        }
        if (this.content[2] !== undefined) {
          this.textBox2.innerHTML = `${this.content[2]}`;
        }
        if (this.content[3] !== undefined) {
          this.textBox3.innerHTML = `${this.content[3]}`;
        }
        this.continue.innerHTML = `<p class="small">ENTER> Continue</p>`;
        clearInterval(this.typing);
      }
    }
  }
  onDeactivate() {
    this.container.style.display = "none";
    clearInterval(this.typing);
    this.resetIntro();
  }
  onPostUpdate(engine) {
    if (engine.input.keyboard.wasPressed(Keys.Enter)) {
      this.enterPress();
    }
  }
}
